export const languages = [
  { name: "English", id: "en" },
  { name: "Español", id: "es" },
  { name: "Afrikaans", id: "af" },
  { name: "Albanian", id: "sq" },
  { name: "Amharic", id: "am" },
  { name: "Arabic", id: "ar" },
  { name: "Armenian", id: "hy" },
  { name: "Azerbaijani", id: "az" },
  { name: "Bengali", id: "bn" },
  { name: "Bosnian", id: "bs" },
  { name: "Bulgarian", id: "bg" },
  { name: "Catalan", id: "ca" },
  { name: "Chinese (Simplified)", id: "zh" },
  { name: "Chinese (Traditional)", id: "zh-TW" },
  { name: "Croatian", id: "hr" },
  { name: "Czech", id: "cs" },
  { name: "Danish", id: "da" },
  { name: "Dutch", id: "nl" },
  { name: "Estonian", id: "et" },
  { name: "Farsi(Persian)", id: "fa" },
  { name: "Filipino, Tagalog", id: "tl" },
  { name: "Finnish", id: "fi" },
  { name: "French", id: "fr" },
  { name: "French (Canada)", id: "fr-CA" },
  { name: "Georgian", id: "ka" },
  { name: "German", id: "de" },
  { name: "Greek", id: "el" },
  { name: "Gujarati", id: "gu" },
  { name: "Haitian Creole", id: "ht" },
  { name: "Hausa", id: "ha" },
  { name: "Hebrew", id: "he" },
  { name: "Hindi", id: "hi" },
  { name: "Hungarian", id: "hu" },
  { name: "Icelandic", id: "is" },
  { name: "Indonesian", id: "id" },
  { name: "Irish", id: "ga" },
  { name: "Italian", id: "it" },
  { name: "Japanese", id: "ja" },
  { name: "Kannada", id: "kn" },
  { name: "Kazakh", id: "kk" },
  { name: "Korean", id: "ko" },
  { name: "Latvian", id: "lv" },
  { name: "Lithuanian", id: "lt" },
  { name: "Macedonian", id: "mk" },
  { name: "Malay", id: "ms" },
  { name: "Malayalam", id: "ml" },
  { name: "Maltese", id: "mt" },
  { name: "Marathi", id: "mr" },
  { name: "Mongolian", id: "mn" },
  { name: "Norwegian (Bokmål)", id: "no" },
  { name: "Pashto", id: "ps" },
  { name: "Polish", id: "pl" },
  { name: "Portuguese (Brazil)", id: "pt" },
  { name: "Portuguese (Portugal)", id: "pt-PT" },
  { name: "Punjabi", id: "pa" },
  { name: "Romanian", id: "ro" },
  { name: "Russian", id: "ru" },
  { name: "Serbian", id: "sr" },
  { name: "Sinhala", id: "si" },
  { name: "Slovak", id: "sk" },
  { name: "Slovenian", id: "sl" },
  { name: "Somali", id: "so" },
  { name: "Spanish (Mexico)", id: "es-MX" },
  { name: "Swahili", id: "sw" },
  { name: "Swedish", id: "sv" },
  { name: "Tamil", id: "ta" },
  { name: "Telugu", id: "te" },
  { name: "Thai", id: "th" },
  { name: "Turkish", id: "tr" },
  { name: "Ukrainian", id: "uk" },
  { name: "Urdu", id: "ur" },
  { name: "Uzbek", id: "uz" },
  { name: "Vietnamese", id: "vi" },
  { name: "Welsh", id: "cy" },
];
